import React from 'react';
import Input from '../common/Input';
import Radio from '../common/Radio';

const BuyerForm = ({ data, onChange }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log('BuyerForm handleChange:', { name, value }); // Debug log
    onChange({
      ...data,
      [name]: value
    });
  };

  const handleTypeChange = (type) => {
    console.log('BuyerForm handleTypeChange:', type); // Debug log
    onChange({
      ...data,
      type
    });
  };

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold text-gray-800">Dados do Comprador</h2>
      
      <div className="space-y-4">
        <div className="flex items-center gap-6">
          <Radio
            id="pf"
            name="buyerType"
            value="pf"
            checked={data.type === 'pf'}
            onChange={() => handleTypeChange('pf')}
            label="Pessoa Física"
          />
          
          <Radio
            id="pj"
            name="buyerType"
            value="pj"
            checked={data.type === 'pj'}
            onChange={() => handleTypeChange('pj')}
            label="Pessoa Jurídica"
          />
        </div>
        
        {data.type === 'pf' ? (
          <div className="space-y-4">
            <Input
              label="Nome Completo"
              id="name"
              name="name"
              value={data.name || ''}
              onChange={handleChange}
              required
            />
            
            <Input
              label="CPF"
              id="cpf"
              name="cpf"
              value={data.cpf || ''}
              onChange={handleChange}
              required
              mask="999.999.999-99"
              placeholder="000.000.000-00"
            />
            
            <Input
              label="Endereço"
              id="address"
              name="address"
              value={data.address || ''}
              onChange={handleChange}
              required
            />
            
            <div className="grid grid-cols-2 gap-4">
              <Input
                label="Cidade"
                id="city"
                name="city"
                value={data.city || ''}
                onChange={handleChange}
                required
              />
              
              <Input
                label="Estado"
                id="state"
                name="state"
                value={data.state || ''}
                onChange={handleChange}
                required
                maxLength={2}
                placeholder="Ex: MA"
              />
            </div>
          </div>
        ) : (
          <div className="space-y-4">
            <Input
              label="Razão Social"
              id="companyName"
              name="companyName"
              value={data.companyName || ''}
              onChange={handleChange}
              required
            />
            
            <Input
              label="CNPJ"
              id="cnpj"
              name="cnpj"
              value={data.cnpj || ''}
              onChange={handleChange}
              required
              mask="99.999.999/9999-99"
              placeholder="00.000.000/0000-00"
            />
            
            <Input
              label="Nome do Representante"
              id="representative"
              name="representative"
              value={data.representative || ''}
              onChange={handleChange}
              required
            />
            
            <Input
              label="CPF do Representante"
              id="representativeCpf"
              name="representativeCpf"
              value={data.representativeCpf || ''}
              onChange={handleChange}
              required
              mask="999.999.999-99"
              placeholder="000.000.000-00"
            />
            
            <Input
              label="Endereço"
              id="address"
              name="address"
              value={data.address || ''}
              onChange={handleChange}
              required
            />
            
            <div className="grid grid-cols-2 gap-4">
              <Input
                label="Cidade"
                id="city"
                name="city"
                value={data.city || ''}
                onChange={handleChange}
                required
              />
              
              <Input
                label="Estado"
                id="state"
                name="state"
                value={data.state || ''}
                onChange={handleChange}
                required
                maxLength={2}
                placeholder="Ex: MA"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BuyerForm;